module.exports = __webpack_public_path__ + "img/summer.3793c891.gif";